export default __webpack_public_path__ + "static/media/IMG-20210825-WA0020.c0640efb.jpg";